import api from "./api"; 

const API_URL = "/groups"; // Base URL for groups endpoints
const USER_URL = "/users"; // Base URL for user-related actions (like search)

export const groupsService = {
  
  /**
   * Fetch all groups the current user belongs to
   */
  async getMyGroups() {
    const res = await api.get(`${API_URL}/my-groups`);
    return res.data;
  },

  /**
   * Create a new group
   * @param {Object} groupData - Contains name and description
   */
  async createGroup(groupData) {
    const res = await api.post(API_URL, groupData);
    return res.data;
  },

  /**
   * Add members to an existing group
   * @param {Object} payload - Contains groupId and array of userIds
   */
  async addMembers(payload) {
    const res = await api.post(`${API_URL}/add-members`, payload);
    return res.data;
  },

  /**
   * Search for users to invite to a group
   * @param {string} query - The name or email to search for
   */
  async searchUsers(query) {
    const res = await api.get(`${USER_URL}/search`, {
      params: { q: query } // Sends as /api/users/search?q=query
    });
    return res.data;
  },

//  get group members

async getGroupMembers(groupId) {
  const res = await api.get(`${API_URL}/${groupId}/members`);
  return res.data;
},
async addMemberByEmail(groupId, email) {
    const response = await api.post(`/groups/${groupId}/members`, { email });
    return response.data;
},

async removeMember(groupId, userId) {
    const response = await api.delete(`/groups/${groupId}/members/${userId}`);
    return response.data;
},

async deleteGroup(groupId) {
  const res = await api.delete(`${API_URL}/${groupId}`);
  return res.data;
},
async updateGroup(groupId,name) {
  const res = await api.put(`${API_URL}/${groupId}`,name);
  return res.data;
}

};